import { AllInboxesStatusTime } from 'store/models/InboxesStatusTime';
import { websocketConstants } from '../constants';
import AppWebSocket from '../models/AppWebSocket';

const initialState = {
  connected: false,
  socketId: null,
  useWebSocket: AppWebSocket.defaultUseWebSocket,
  connectError: null as null | string,
  allInboxesStatusLatestReceivedTimeWithData: AllInboxesStatusTime.getDefault(),
  allInboxesStatusLatestReceivedTime: AllInboxesStatusTime.getDefault(),
};

export const websocket = (state = initialState, action) => {
  switch (action.type) {
    case websocketConstants.WS_CONNECTED:
      return {
        ...state,
        socketId: action.payload.socketId,
        connected: true,
        connectError: null, // clear connect error after connected
      };
    case websocketConstants.WS_DISCONNECTED:
      return {
        ...state,
        socketId: null, // for tracking
        connected: false,
      };
    case websocketConstants.WS_CONNECT_ERROR:
      return {
        ...state,
        connectError: action.payload.message || 'failed to connect',
      };
    case websocketConstants.SET_USE_WEB_SOCKET:
      return {
        ...state,
        useWebSocket: action.payload.useWebSocket,
      };
    case websocketConstants.UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME_WITH_DATA:
      if (!action.payload.data)
        throw Error(`payload.data is missing`);
      return {
        ...state,
        allInboxesStatusLatestReceivedTimeWithData:
          action.payload.data,
      };
    case websocketConstants.UPDATE_ALL_INBOXES_STATUS_LATEST_RECEIVED_TIME:
      if (!action.payload.data)
        throw Error(`payload.data is missing`);
      return {
        ...state,
        allInboxesStatusLatestReceivedTime: action.payload.data,
      };
    default:
      return state;
  }
};
